import { usePremium } from "context/PremiumContext";
import UpgradeBox from "../UpgradeBox";
import { summary } from "./helper";
import "./style.scss";

function ActivitySummary({ profileData, onUpgradeClick }) {
  const { isPremium } = usePremium();

  const firstHalf = summary.slice(0, 4);
  const secondHalf = summary.slice(4, 8);

  const renderItem = (item, i) => (
    <div key={i} className="flex flex-col gap-4 item-container">
      <span className="key-label">{item.label}</span>
      <p className="key-value">{profileData?.[item.dataKey] ?? 0}</p>
    </div>
  );

  const handleUpgradeClick = () => {
    if (onUpgradeClick) {
      onUpgradeClick();
    }
  };

  return (
    <div className="activity-summary-wrapper">
      {firstHalf.map(renderItem)}
      <div
        className={`flex flex-wrap gap-6 relative premium-items ${!isPremium ? "premium-container" : ""}`}
      >
        {secondHalf.map((item, i) => renderItem(item, i + 4))}
        {!isPremium && <UpgradeBox onClick={handleUpgradeClick} />}
      </div>
    </div>
  );
}

export default ActivitySummary;
